import { Immutability } from "@bitory-gmbh/nidavellir";
import { Artefact, Document, DocumentOwnership } from "@bitory-gmbh/bsm";
import { Position } from "@/services/backend/vbs/treatments/types/position";
import { Segment } from "@/services/backend/vbs/treatments/types/segment";
import { Common } from "@/services/backend/documents/types/common";

export interface Treatment
  extends Document, Artefact, Immutability, DocumentOwnership, Common, Prices {
  positions: Position[];
  segments: Segment[];
  totalCleanTime: number;
  totalPercentCompleted: number;
  remark: string;
}

export function uniqueAreas(treatment: Treatment) {
  return treatment!.positions
    .map((position) => position.area)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort((a, b) => a.localeCompare(b));
}

export interface Prices {
  totalBasePrice: number;
  totalCycleDiscount: number;
  totalSpecialDiscount: number;
  totalFinalPrice: number;
}
